import { Icon } from '@grow-components/Icon/Icon';
import React, { FC, useMemo } from 'react';
import styles from './item.module.scss';
import { ESuggestionType, IProps } from './types';

export const SuggestionItem: FC<IProps> = ({ title, description, type }) => {

  const icon = useMemo(() => {
    switch (type) {
    case ESuggestionType.PERSON:
      return (<Icon icon={'user'} />);

    case ESuggestionType.GROUP:
      return (<Icon icon={'users'} />);

    default:
      return (<Icon icon={'clock'} />);
    }
  }, [type]);

  return (
    <div className={styles.container}>
      <span className={styles.iconHolder}>{icon}</span>
      <div className={styles.title}>{title}</div>
      <div className={styles.description}>{description}</div>
    </div>
  );
};
